import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { SMART_BANNER_ENTITY, SmartBannerState } from '../smart-banner-state';

export type SmartBannerReducers = SmartBannerState;

export function getReducers(): ActionReducerMap<SmartBannerReducers> {
  return {
    smartBanner: StateUtils.loaderReducer(SMART_BANNER_ENTITY),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<SmartBannerReducers>> = new InjectionToken<
  ActionReducerMap<SmartBannerReducers>
>('SmartBannerReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
